/* ==========================================================================
   LUJE — cart shipping estimator: ship-to countries only, and say "Free".

   Two problems this fixes, both reported 2026-08-08.

   1. The country select offered all 237 countries. LUJÉ has ten markets
      covering 41 countries; for the rest the estimator returned nothing useful
      and, worse, implied we deliver there. The allow-list comes from
      `localization.available_countries` via a data attribute, so it tracks the
      shop's markets automatically — nothing is hardcoded here.

   2. A free rate rendered as "€0,00". Numerically true, commercially wasted:
      "Free" is the thing the shopper is looking for, and it is the payoff of
      the progress bar above it. Zero-priced rates are relabelled and marked.

   Both are post-processing steps over the theme's own script (app.min.js),
   which is minified vendor code. Nothing here patches or depends on its
   internals — it observes the DOM it produces. If this file fails to load, the
   estimator still works exactly as it did before.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- 1. restrict the country list ------------------------------------ */

  function prune(select) {
    var raw = select.getAttribute('data-allowed-countries') || '';
    var allowed = raw.split(',').map(function (s) { return s.trim().toUpperCase(); })
                     .filter(Boolean);
    if (!allowed.length) return;               // no list -> leave well alone
    if (select.options.length <= allowed.length) return;  // already pruned

    Array.prototype.slice.call(select.options).forEach(function (opt) {
      var v = (opt.value || '').trim().toUpperCase();
      if (v && allowed.indexOf(v) === -1) opt.remove();
    });

    // If the previously selected country is gone, fall back to the default
    // (the shopper's own market) and tell the province selector to catch up.
    var want = (select.getAttribute('data-default') || '').trim().toUpperCase();
    var have = (select.value || '').trim().toUpperCase();
    if (!have || allowed.indexOf(have) === -1) {
      if (allowed.indexOf(want) !== -1) select.value = want;
      else select.selectedIndex = 0;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function watchCountrySelects(scope) {
    (scope || document).querySelectorAll('select[data-allowed-countries]').forEach(function (sel) {
      prune(sel);
      if (sel.__lujePruneWatched) return;
      sel.__lujePruneWatched = true;
      // The theme populates the select asynchronously; re-prune when it does.
      new MutationObserver(function () { prune(sel); })
        .observe(sel, { childList: true });
    });
  }

  /* ---- 2. relabel free rates ------------------------------------------- */

  // Any money string whose digits are all zeros — works for €0,00, $0.00,
  // ¥0 and so on without needing to know the shop's money format.
  function isZeroMoney(text) {
    var digits = (text || '').replace(/[^\d]/g, '');
    return digits.length > 0 && /^0+$/.test(digits);
  }

  function freeLabel() {
    var host = document.querySelector('[data-free-shipping-label]');
    return host ? host.getAttribute('data-free-shipping-label') : '';
  }

  function relabelFreeRates(container) {
    var label = freeLabel();
    if (!label) return;                        // no translated label -> leave the amount

    container.querySelectorAll('p').forEach(function (p) {
      var span = p.querySelector('span');
      if (!span || span.dataset.lujeFree === '1') return;
      if (!isZeroMoney(span.textContent)) return;
      span.textContent = label;
      span.dataset.lujeFree = '1';
      p.classList.add('is-free-rate');
    });
  }

  function watchRateResults() {
    document.querySelectorAll('.scd__addon-message, .scd__addon .shipping-content').forEach(function (box) {
      if (box.__lujeRateWatched) return;
      box.__lujeRateWatched = true;
      relabelFreeRates(box);
      new MutationObserver(function () { relabelFreeRates(box); })
        .observe(box, { childList: true, subtree: true });
    });
  }

  /* ---- wiring ---------------------------------------------------------- */

  function scan() { watchCountrySelects(); watchRateResults(); }

  // The drawer is injected after load, so watch for it arriving.
  var container = document.getElementById('cart-drawer-container');
  if (container) new MutationObserver(scan).observe(container, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('click', function () { setTimeout(scan, 400); }, true);
  scan();
})();
